<template>
    <div class="object-info" :class="{ active: open }">
        <div class="menu">
            <font-awesome-icon
                icon="times"
                class="fa-lg dismiss-icon"
                @click="$emit('object-info:dismiss')"
            />
            <button
                v-if="inverse === true"
                class="inverse-valid-btn osm-button default"
                :disabled="isInverseFormValid() ? false : true"
                @click="validInverseForm"
            >
                ✓
            </button>
        </div>
        <div class="scroller">
            <div class="section">
                <div class="header">Sélection</div>
                <div class="body">
                    <template v-if="inverse !== true">
                        <div
                            class="rat-object"
                            v-for="(object, index) in value.objects"
                            :key="index"
                        >
                            <div class="row">
                                <div class="col">Identifiant</div>
                                <div class="col">
                                    {{ object[`${value.rattachment.fid}_old_rattachment`] }}
                                </div>
                                <div class="col">
                                    <button class="close-btn" @click="unselectObject(object)">
                                        x
                                    </button>
                                </div>
                            </div>
                            <div v-for="(item, index) in object" :key="index">
                                <div
                                    class="row"
                                    v-if="index !== `${value.rattachment.fid}_old_rattachment`"
                                >
                                    <div class="col">{{ index }}</div>
                                    <div class="col">{{ item }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="inverse === true">
                        <div class="id-list">
                            <div class="row"><div class="col">Filaires sélectionnés</div></div>
                            <div class="id" v-for="(object, index) in value.objects" :key="index">
                                <div>
                                    <label>{{ object[`${value.rattachment.fid}`] }}</label>
                                </div>
                                <div>
                                    <button class="close-btn" @click="unselectObject(object)">
                                        x
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="attributs-list">
                            <div class="row"><div class="col">Attributs à modifier :</div></div>
                            <template v-if="object.objects[0]">
                                <div v-for="(item, index) in rattachmentInverseFList" :key="index">
                                    <div class="row">
                                        <div class="col">{{ item }}</div>
                                        <div class="col">
                                            <CustomInput
                                                type="string"
                                                required
                                                class="stretch"
                                                v-model="object.objects[0][item]"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomInput from './../../components/Input';

export default {
    props: {
        open: Boolean,
        object: Object,
        keys: Array,
        inverse: { type: Boolean, default: false },
    },
    data() {
        return {
            isHistoryOpen: false,
            rattachmentInverseFList: [],
            rattachmentInverseForm: {},
        };
    },
    mounted() {
        if (this.inverse === true) {
            if (
                this.object &&
                this.object.objects &&
                this.object.objects[0] &&
                this.object.rattachment &&
                this.object.rattachment.flist &&
                this.object.rattachment.flist.split
            ) {
                this.rattachmentInverseFList = this.object.rattachment.flist.split(',');
                for (let i = 0; i < this.rattachmentInverseFList.length; i++) {
                    const attr = this.rattachmentInverseFList[i];
                    if (typeof this.object.objects[0][attr] === undefined) {
                        this.object.objects[0][attr] = '';
                    }
                }
            }
        }
    },
    computed: {
        value() {
            return this.object || {};
        },
    },
    methods: {
        /**
         * Vérifie que tous les champs soient remplis
         */
        isInverseFormValid() {
            if (
                this.object &&
                this.object.objects &&
                this.object.objects[0] &&
                this.rattachmentInverseFList
            ) {
                let valid = false;
                for (let i = 0; i < this.rattachmentInverseFList.length; i++) {
                    const attr = this.rattachmentInverseFList[i];
                    if (this.object.objects[0][attr] && this.object.objects[0][attr].length > 0) {
                        valid = true;
                    }
                }
                return valid;
            }
            return false;
        },
        /**
         * Validation d'un objet de rattachement inverse
         */
        validInverseForm() {
            if (this.isInverseFormValid()) {
                this.fillFields();
                this.$emit('object-info:validInverseForm');
            } else {
                console.error('Formulaire incomplet');
            }
        },
        unselectObject(object) {
            this.$emit('unselect:object', object);
        },
        fillFields() {
            if (
                this.object &&
                this.object.objects &&
                this.object.objects[0] &&
                this.object.rattachment &&
                this.object.rattachment.flist &&
                this.object.rattachment.flist.split
            ) {
                this.rattachmentInverseFList = this.object.rattachment.flist.split(',');

                for (let i = 0; i < this.rattachmentInverseFList.length; i++) {
                    const attr = this.rattachmentInverseFList[i];

                    // Met une chaine vide pour les champs non remplis
                    if (typeof this.object.objects[0][attr] === 'undefined') {
                        this.object.objects[0][attr] = '';
                    }

                    // Renseigne les attributs des autres objets
                    if (this.object.objects.length > 1) {
                        for (let ii = 1; ii < this.object.objects.length; ii++) {
                            this.object.objects[ii][attr] = this.object.objects[0][attr];
                        }
                    }
                }
            }
        },
    },
    components: {
        CustomInput,
    },
};
</script>

<style lang="scss">
$menu-width: 240px;
$menu-height: 50px;

.object-info {
    display: none;
    position: fixed;
    z-index: 1100;
    top: 0;
    left: 0;
    width: $menu-width;
    height: 100%;
    background-color: #fafafaed;
    transition: all 0.3s ease;

    &.active {
        display: inherit;
        left: $menu-width;
        transition: all 0.3s ease;
        border-radius: 0 30px 0 0;
        border-top: solid #6c3e91 1px;
        border-right: solid #6c3e91 1px;
        border-bottom: solid #6c3e91 1px;
    }

    .menu {
        height: $menu-height;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .inverse-valid-btn {
            padding: 0px 6px;
            border-radius: 3px;
            margin-right: 23px;

            &:disabled {
                color: #fff;
                background-color: #6c757d;
                border-color: #6c757d;
                cursor: not-allowed;
            }
        }

        .dismiss-icon {
            color: #2a2a2a;
            padding: 15px;
            cursor: pointer;
        }

        .object-actions {
            display: flex;
            margin: 15px;

            .actions--icon-accept {
                color: #ffffff;
                background-color: #93c11f;
                border-radius: 3px;
                padding: 5px;
                margin-right: 5px;
                cursor: pointer;
            }

            .actions--icon-waiting {
                color: #ffffff;
                background-color: #6c3e91;
                border-radius: 3px;
                padding: 5px;
                margin-right: 5px;
                cursor: pointer;
            }

            .actions--icon-reject {
                color: #ffffff;
                background-color: #ea5b0c;
                border-radius: 3px;
                padding: 5px;
                margin-right: 5px;
                cursor: pointer;
            }
        }
    }

    .scroller {
        position: absolute;
        top: $menu-height;
        bottom: 0;
        overflow-y: auto;
        width: 100%;
        /*scrollbar-color: #6c3e91 #fff;*/
    }

    .section {
        .header {
            height: 40px;
            background-color: rgba(212, 216, 221, 0.2); // #d4d8dd;
            display: flex;
            align-items: center;
            padding-left: 22px;
            color: #2a2a2a;
            text-transform: uppercase;
            font-weight: bold;
        }

        .body {
            .close-btn {
                box-shadow: inset 0px 1px 0px 0px #f5978e;
                background: linear-gradient(to bottom, #f24537 5%, #c62d1f 100%);
                background-color: #f24537;
                border-radius: 10px;
                border: 1px solid #d02718;
                display: inline-block;
                cursor: pointer;
                color: #ffffff;
                font-family: Arial;
                font-size: 12px;
                font-weight: bold;
                padding: 3px 6px;
                text-decoration: none;
                text-shadow: 0px 1px 0px #810e05;
                margin-top: 4px;
                margin-bottom: 4px;
            }
            .close-btn:hover {
                background: linear-gradient(to bottom, #c62d1f 5%, #f24537 100%);
                background-color: #c62d1f;
            }
            .close-btn:active {
                position: relative;
                top: 1px;
            }

            .id-list {
                .id {
                    display: flex;
                    flex-direction: row;
                    align-content: end;
                    align-items: center;
                    justify-content: flex-end;
                    margin-left: 50px;
                    margin-right: 50px;

                    .close-btn {
                        margin-left: 40px;
                    }
                }
            }
            .attributs-list {
                margin-top: 50px;
            }
            .rat-object {
                border: 1px solid #666;
                border-radius: 5px;
                margin: 5px;

                .close-btn {
                    margin-right: -15px;
                }
            }
            .row {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 5px 10px 5px 10px;
                margin: 2px 10px 2px 10px;
                align-items: center;
                flex-wrap: wrap;

                &.active-key {
                    border-style: solid;
                    border-color: gray;
                    border-width: 1px;
                    border-radius: 10px;
                    background: #faed27c8;
                }

                .col {
                    display: flex;
                    flex-direction: column;
                    word-break: break-word;

                    &:first-child {
                        font-size: 13px;
                        font-weight: 600;
                        margin-right: 15px;
                    }

                    &:last-child {
                        /* text-align: right; */
                    }

                    &.deleted {
                        text-decoration: line-through;
                    }

                    .link {
                        text-decoration: none;
                        color: #6c3e91;
                        font-weight: bolder;
                    }
                    .link-contrib {
                        text-decoration: none;
                    }
                    span.old-value {
                        text-decoration: line-through;
                        // margin-right: 1em;
                    }

                    input {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
